<template>
  <footer class="footer">
    <div class="container">
      <div class="columns">
        <div class="column is-hidden-touch">
          <h4>Infos</h4>
          <ul>
            <li v-for="(item, index) in menu"><a :href="item.url.path"><span class="icon" v-if="getIcon(item.label)"><font-awesome-icon :icon='getIcon(item.label)' /></span>{{ item.label }}</a></li>
          </ul>
        </div>
        <div v-if="content.fieldSpalten" v-for="(item, index) in content.fieldSpalten" class="column">
          <h4 v-if="item.entity.fieldTitel">{{ item.entity.fieldTitel }}</h4>
          <div v-if="item.entity.fieldText" class="text" v-html="item.entity.fieldText.value"></div>
        </div>
        <div v-if="content.fieldSocialLinks" class="column">
          <h4>Social Links</h4>
          <div class="social">
            <ul>
              <li><a v-if="content.fieldSocialLinks.entity.fieldFacebookLink" :href="content.fieldSocialLinks.entity.fieldFacebookLink" target="_blank"><span class="icon"><font-awesome-icon :icon="[ 'fab', 'facebook-square' ]" /></span>Facebook</a></li>
              <li><a v-if="content.fieldSocialLinks.entity.fieldInstagramLink" :href="content.fieldSocialLinks.entity.fieldInstagramLink" target="_blank"><span class="icon"><font-awesome-icon :icon="[ 'fab', 'instagram' ]"/></span>Instagram</a></li>
              <li><a v-if="content.fieldSocialLinks.entity.fieldAmazonLink" :href="content.fieldSocialLinks.entity.fieldAmazonLink" target="_blank"><span class="icon"><font-awesome-icon :icon="[ 'fab', 'amazon' ]"/></span>Amazon Smile</a></li>
              <li><a v-if="content.fieldSocialLinks.entity.fieldTwitterLink" :href="content.fieldSocialLinks.entity.fieldTwitterLink" target="_blank"><span class="icon"><font-awesome-icon :icon="[ 'fab', 'twitter' ]"/></span>Tweiiter</a></li>
              <li><a v-if="content.fieldSocialLinks.entity.fieldAppstoreLink" :href="content.fieldSocialLinks.entity.fieldAppstoreLink" target="_blank"><span class="icon"><font-awesome-icon :icon="[ 'fab', 'apple' ]"/></span>Apple Store</a></li>
              <li><a v-if="content.fieldSocialLinks.entity.fieldPlaystoreLink" :href="content.fieldSocialLinks.entity.fieldPlaystoreLink" target="_blank"><span class="icon"><font-awesome-icon :icon="[ 'fab', 'google-play' ]"/></span>Google PlayStore</a></li>
            </ul>
          </div>
        </div>

      </div>
    </div>
  </footer>
</template>

<script>
    import menuQuery from '@/apollo/queries/MenuQuery.gql';

    export default {
        props: {
            content: {},
        },
        data() {
          return {
            menu: {},
          }
        },
        apollo: {
          menu: {
            prefetch: true,
            query: menuQuery,
            options: {
              errorPolicy: 'all',
            },
            update(data) {
              return data.menuByName.links;
            }
          },
        },
        methods: {
            getMenuChildren: function(parent) {
                var parent_id = parent.id;
                var return_array = [];
                for(var item in this.menu_data) {
                    if(this.menu_data[item].attributes.parent === 'menu_link_content:' + parent_id) {
                        return_array.push(this.menu_data[item]);
                    }
                }
                return return_array;
            },
            getHref: function(link) {
                var path = link['uri'].split(':')[1];
                return path;
            },
            getIcon: function(value) {
              if(value == "Wir") return "portrait";
              else if (value == "Gruppen") return "play";
              else if (value == "Freizeiten") return "mountain";
              else if (value == "Musik") return "music";
              else if (value == "Events") return "calendar";
              else if (value == "Kontakt") return "paper-plane";
              return "hand-point-right";
            },
        },
    }
</script>
